<div class="prompts">
  <ng-container *ngFor="let prompt of prompts">
    <div class="prompt" (click)="handlePromptClick(prompt)">
      {{ prompt }}
    </div>
  </ng-container>
</div>
